import { combineReducers } from 'redux'

import { authProviderReducer } from '../../containers/AuthProvider'
import { cfmpReducer } from '../../containers/Cfmp'
import { snackbarProviderReducer } from '../../containers/SnackbarProvider'

/**
 * Reducers configuration.
 * Combines all reducers into a single root reducer.
 */
export const rootReducer = combineReducers({
  authProvider: authProviderReducer,
  cfmp: cfmpReducer,
  snackbarProvider: snackbarProviderReducer
})
